import type { Release } from '../releases';

export default {
  id: '2026-11-03-pilot-everywhere',
  at: '2026-11-04T09:35:00Z',
  title: 'Pilot отвечает в базе знаний, собирает отчёты, читает PDF-графики и находит похожие предложения',
  modules: ['ai'],
  items: [
    'База знаний: вопрос Pilot обычными словами — ответ по статьям, которые вам открыты, со ссылками на них. Если ответа в статьях нет, Pilot так и скажет.',
    'Отчёты: «Спросить Pilot» в конструкторе составляет настройку отчёта по вашему вопросу — источник, колонки, отбор и итоги. Данные читает сам портал в ваших правах, поэтому Pilot не может показать больше, чем вы видите.',
    'График: в окне загрузки можно выбрать PDF-график подрядчика. Pilot переписывает из него работы, даты и связи; даты и длительности, которых нет в PDF, не берутся. Перед загрузкой график сверяется, и вы подтверждаете его сами.',
    'Предложения: похожие на ваше предложение Pilot подбирает по смыслу, а не только по общим словам.',
    'Pilot доступен тем, у кого есть право «Пользоваться ИИ-помощником», и только когда модель прошла контрольную проверку. Каждый ответ помечен «Подготовлено ИИ».',
  ],
  why: 'База знаний, отчёты, загрузка PDF-графика и подбор похожих предложений были готовы принять Pilot, но не были к нему подключены: они отвечали «Pilot пока не подключён».',
  link: '/kb',
} satisfies Release;
